import React, { useState } from "react";
import { Button, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getTrainingFile } from "../../redux/capacitacionDesarrollo/TrainingEvents/actions";

const LinkDescargaCapacitacion = (props) => {
  //*states
  const [loader, setLoader] = useState(false);
  //*variables
  const dispatch = useDispatch();
  return (
    <OverlayTrigger
      placement="auto"
      overlay={<Tooltip {...props}>Descargar convocatoria a capacitación</Tooltip>}
    >
      <Button
        size="sm"
        className="text-secondary rounded"
        variant="link"
        type="button"
        onClick={() =>
          dispatch(
            getTrainingFile(props.id, setLoader)
          )
        }
        disabled={loader}
      >
        {loader ? (
          <Spinner
            className="ml-2"
            animation="border"
            variant="primary"
            size="sm"
          />
        ) : (
          <i className="material-icons">download</i>
        )}
      </Button>
    </OverlayTrigger>
  );
};

export default LinkDescargaCapacitacion;
